import React from "react";
import styled from "styled-components";
import { Colors } from "../ColorConstants";

const Section = ({ heading, subText }) => {
  return (
    <Card>
      <Heading>{heading}</Heading>
      <br />
      <SubText>{subText}</SubText>
    </Card>
  );
};

const Card = styled.div`
  flex: 1;
  padding: 1rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  text-align: center;
  margin-bottom: 1rem;
  margin-left: 1rem;

  max-width: 300px;
  @media (max-width: 700px) {
    margin-right: 0rem;
    margin-left: 0rem;
  }
`;

const Heading = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${Colors.brickRed};
`;

const SubText = styled.span`
  font-size: 1.2rem;
  font-style: 400;
  color: ${Colors.secondaryBlack};
`;

export default Section;
